import { render, staticRenderFns } from "./cadastrarContaUsuario.vue?vue&type=template&id=878ba74c&"
import script from "./cadastrarContaUsuario.vue?vue&type=script&lang=js&"
export * from "./cadastrarContaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./cadastrarContaUsuario.vue?vue&type=style&index=0&id=878ba74c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports